import axiosInstance from "../axiosInstance";
import { ApiResponse } from "@/types/apiResponse";

export interface LevelProgress {
  level: number;
  xpIntoLevel: number;
  xpForThisLevel: number;
  nextLevelXp: number;
}

export interface TardStreak {
  current: number;
  longest: number;
  last_date: string | null;
}

export interface TardProfile {
  xp: number;
  level: number;
  tard_score: number;
  tier: string;
  skill_pts: number;
  consistency_pts: number;
  mocks_completed: number;
  practice_sessions: number;
  questions_answered: number;
  correct_answers: number;
  overall_accuracy: number; // 0-1
  active_days_30d: number;
  level_progress: LevelProgress;
  percentile_label: string | null;
  streak: TardStreak;
}

export interface ProfileShare {
  share_code: string;
  share_url: string;
  image_url: string;
  display_name: string;
  is_anonymous: boolean;
  enabled: boolean;
  stats: TardProfile;
}

// Tier -> accent colour, mirrors the backend card template.
export const TIER_COLORS: Record<string, string> = {
  Rookie: "#94a3b8",
  Aspirant: "#38bdf8",
  Contender: "#a78bfa",
  Achiever: "#fb923c",
  Topper: "#facc15",
  "GATE Elite": "#f43f5e",
};

export const tierColor = (tier: string): string =>
  TIER_COLORS[tier] ?? TIER_COLORS.Rookie;

export const getMyProfile = async (): Promise<ApiResponse<TardProfile>> => {
  const res = await axiosInstance.get("/profile/me");
  return res.data;
};

export interface ProfileShareSummary {
  share_code: string;
  share_url: string;
  enabled: boolean;
}

// Light read — no card render server-side. data is null until the user
// mints a share (via createProfileShare / the share modal).
export const getProfileShare = async (): Promise<
  ApiResponse<ProfileShareSummary | null>
> => {
  const res = await axiosInstance.get("/profile/share");
  return res.data;
};

export const createProfileShare = async (): Promise<
  ApiResponse<ProfileShare>
> => {
  const res = await axiosInstance.post("/profile/share");
  return res.data;
};

export const updateProfileShare = async (patch: {
  display_name?: string;
  is_anonymous?: boolean;
  enabled?: boolean;
}): Promise<ApiResponse<ProfileShare>> => {
  const res = await axiosInstance.patch("/profile/share", patch);
  return res.data;
};
